import { useEffect, useRef } from 'react';
// https://reactjs.org/docs/hooks-faq.html#how-to-get-the-previous-props-or-state
export function usePreviousRef(callback, initial = undefined) {
    const ref = useRef(initial);
    useEffect(()=>{
        ref.current = callback();
    });
    return ref;
}
export function usePrevious(value) {
    return usePreviousRef(()=>value).current;
}
const $initial = Symbol('initial');
export function usePreviousIfEqual(value, compare = Object.is) {
    let result = value;
    const ref = usePreviousRef(()=>result, $initial);
    const previous = ref.current;
    if (previous !== $initial && compare(previous, value)) {
        result = previous;
    }
    return result;
}

//# sourceMappingURL=usePrevious.js.map